<template>
  <v-dialog persistent v-model="dialog" :width="isOnMobile ? '100%' : 600">
    <v-card class="ma-0 pa-2">
      <div class="ma-0 pa-0 box-container" style="overflow: hidden; max-height: 500px;">
        <div class="row-header" style="width: 100%;">
          <v-row justify="center" align="center" class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <span>{{ isInStorno ? `Кредитно известие към фактура № ${stornoRcpInfo.invoiceNum}` : "Кредитно известие" }}</span>
            <v-spacer></v-spacer>
            <v-btn color="error" text fab small @click="cancelCreditNote">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </div>
        <v-divider class="ma-0 pa-0 row-header"></v-divider>
        <div class="ma-0 pa-0 row-content-limited">
          <div justify="start" class="pa-0 ma-0 pl-1" v-if="isInStorno">
            <div>
              Купувач:
              <u>{{ invBuyer }}</u>
            </div>
            <div>
              Адрес:
              <u>{{ invAddress }}</u>
            </div>
            <div>
              Издадена на:
              <u>{{ stornoRcpInfo.dateAndTime.toTremolFpString() }}</u>
            </div>
          </div>
          <v-form class="ma-0 pa-0" ref="invoiceForm" v-on:submit.prevent v-model="validated" lazy-validation>
            <v-row v-if="isInManualStorno" class="ma-1 pt-3">
              <v-select class="ma-0 pa-0" dense item-text="name" :items="optionsStornoReasons" v-model="stornoReason" hide-details label="Причина"></v-select>
            </v-row>
            <v-row class="ma-1 pa-0 pt-3" justify="center">
              <v-text-field class="ma-1 pa-0" v-if="!isInStorno" autofocus @keydown.enter.stop="findInvoiceForStorno" v-model.number="rcpNum" :rules="validRcp_Num" label="Номер на бон или QR код"></v-text-field>
              <!-- <v-btn class="ma-0 pa-0" @click="$refs.refQRScanner.click(); startScanner();"> -->
              <v-btn v-if="isOnAndroid && !isInStorno && !isInManualStorno" class="ma-0 pa-0" @click="startScanner()">
                <v-icon>mdi-camera</v-icon>
              </v-btn>
              <!-- <input style="visibility: hidden;  width: 0px" ref="refQRScanner" type="file" accept="txt/*" capture="camera" v-on:change="qrScanned" /> -->
            </v-row>
            <div v-if="isInManualStorno">
              <v-row class="ma-1 py-3">
                <v-dialog ref="caldendarDialogRef" v-model="modalCalendar" :return-value.sync="rcpDate" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field class="ma-0 pt-3" v-on="on" maxlength="10" height="17" dense fluid label="Дата и час на издаване на фискалния бон" color="default" :value="getFullDate(rcpTime, rcpDate).toStringWithFormat('dd.MM.yyyy hh:mm:ss')"></v-text-field>
                  </template>
                  <v-date-picker v-if="!calendarDateSet" firstDayOfWeek="1" type="date" locale="bg" v-model="rcpDate">
                    <v-row class="ma-0 pa-0" justify="end">
                      <v-btn color="warning" tile class="elevation-0 mr-1" @click="modalCalendar = false">Отказ</v-btn>
                      <v-btn color="success" tile class="elevation-0 ml-1" @click="calendarDateSet = true">OK</v-btn>
                    </v-row>
                  </v-date-picker>
                  <v-time-picker v-else v-model="rcpTime" use-seconds format="24hr">
                    <v-row class="mr-2 ml-2" justify="end">
                      <v-btn color="error" tile class="elevation-0 mr-1" @click="
                            () => {
                              modalCalendar = false;
                              calendarDateSet = false;
                            }
                          ">Отказ</v-btn>
                      <v-btn color="success" tile class="elevation-0 ml-1" @click="
                            () => {
                              $refs.caldendarDialogRef.save(rcpDate);
                              modalCalendar = false;
                              calendarDateSet = false;
                            }
                          ">OK</v-btn>
                    </v-row>
                  </v-time-picker>
                </v-dialog>
              </v-row>
              <v-row class="ma-1 py-2">
                <v-text-field class="ma-0 pa-0" v-model="fmNum" max-length dense :rules="validFM_Num" label="Номер на фискална памет"></v-text-field>
              </v-row>
              <v-row class="ma-1 pb-2">
                <v-text-field dense :rules="validInv_Num" class="ma-0 pa-0" v-model="invRcpNum" label="Към фактура №"></v-text-field>
              </v-row>
              <v-row class="ma-1 pt-3" v-if="withClient && !fp.maxSupportedClients == 0">
                <v-autocomplete :rules="required" class="ma-0 pa-0" dense item-text="CustomFirmName" :items="clients" v-model="client" label="Клиенти"></v-autocomplete>
              </v-row>
              <div v-if="!withClient">
                <v-row class="ma-1 pb-2">
                  <v-text-field dense :rules="validInv_Buyer" @input="fixName" class="ma-0 pa-0" v-model="invBuyer" label="Име на фирма"></v-text-field>
                </v-row>
                <v-row class="ma-1 pb-2">
                  <v-text-field dense :rules="validInv_Address" @input="fixName" class="ma-0 pa-0" v-model="invAddress" label="Адрес"></v-text-field>
                </v-row>
                <v-row class="ma-1 pb-2">
                  <v-select class="ma-0 pa-0" @change="clearUIC" dense item-text="name" :items="optionUIC" v-model="uicFormat" label="Тип на ЕИК"></v-select>
                </v-row>
                <v-row class="ma-1 pb-2">
                  <v-text-field v-if="uicFormat == optionUIC[0].value" :rules="validEIK" dense class="ma-0 pa-0" v-model="invUIC" :label="chosenUIC" required></v-text-field>
                  <v-text-field v-else-if="uicFormat == optionUIC[1].value" :rules="validEGN" class="ma-0 pa-0" v-model="invUIC" :label="chosenUIC" required></v-text-field>
                  <v-text-field v-else-if="uicFormat == optionUIC[2].value" :rules="validLNCH" dense class="ma-0 pa-0" v-model="invUIC" :label="chosenUIC" required></v-text-field>
                  <v-text-field v-else dense class="ma-0 pa-0" :rules="required" v-model="invUIC" :label="chosenUIC" required></v-text-field>
                  <!-- <v-text-field dense class="ma-0 pa-0" :rules="uicFormat==optionUIC[0].value? validEIK: uicFormat==optionUIC[1].value? validEGN: uicFormat==optionUIC[2].value? validLNCH: undefined" v-model="invUIC" :label="chosenUIC[0]" required></v-text-field> -->
                </v-row>
                <v-row class="ma-1 pb-2">
                  <v-text-field dense :rules="validVAT_Num" class="ma-0 pa-0" v-model="invVAT_Num" label="ДДС номер"></v-text-field>
                </v-row>
                <v-row class="ma-1 pb-1">
                  <v-text-field dense :rules="validInv_Rcpnt" @input="fixName" class="ma-0 pa-0" v-model="invRcpnt" label="Получател"></v-text-field>
                </v-row>
              </div>
            </div>
            <!-- <v-alert dismissible tile v-if="error != ''" dense border="left" type="warning">{{ error }}</v-alert> -->
            <div v-if="isInStorno">
              <v-row class="ma-1 pt-3">
                <v-select class="ma-0 pa-0" dense item-text="name" :items="optionsStornoReasons" v-model="stornoReason" label="Причина за сторно"></v-select>
              </v-row>
              <v-simple-table dense :height="stornoRcpInfo.articles.length * (isOnMobile? 50:32) + 50" style="overflow-y: auto;">
                <thead>
                  <tr>
                    <th class="text-center">Избор</th>
                    <th class="text-start">Артикул</th>
                    <th v-if="!isOnMobile || currentResBP == `sm`" class="text-center">Дан. група</th>
                    <th v-if="!isOnMobile || currentResBP == `sm`" class="text-center">Бр./Кол.</th>
                    <th v-if="!isOnMobile || currentResBP == `sm`" class="text-center">Ед. цена</th>
                    <th class="text-center">Обща сума</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="plu in stornoRcpInfo.articles" :key="plu.Index">
                    <td>
                      <v-row justify="center" align="center">
                        <input :disabled="plu.IsVoided" type="checkbox" dense v-bind:id="plu.Index" v-bind:value="plu" v-model="articlesToStorno" />
                      </v-row>
                    </td>
                    <td :class="plu.IsVoided?'grey--text':''" class="text-center">{{ plu.Name }}</td>
                    <td :class="plu.IsVoided?'grey--text':''" v-if="!isOnMobile || currentResBP == `sm`" class="text-center">{{ plu.VAT }}</td>
                    <td :class="plu.IsVoided?'grey--text':''" v-if="!isOnMobile || currentResBP == `sm`" class="text-center">{{ plu.Qty }}</td>
                    <td :class="plu.IsVoided?'grey--text':''" v-if="!isOnMobile || currentResBP == `sm`" class="text-end">{{ plu.Price }}</td>
                    <td :class="plu.IsVoided?'grey--text':''" class="text-end">{{ plu.Price_Total }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </v-form>
        </div>
        <div class="row-header">
          <v-row v-if="isInManualStorno" class="ma-0 pa-0 mt-2" justify="end">
            <v-row class="ma-0 pa-0 ma-2" justify="space-between">
              <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="elevation-0" @click="isInManualStorno = !isInManualStorno">
                <v-icon color="#1685c9">mdi-arrow-left-bold</v-icon>
                <span>Назад</span>
              </v-btn>
              <!-- <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="elevation-0" @click="withClient = !withClient" v-if="!fp.maxSupportedClients == 0">
                <v-icon color="#1685c9" small>{{ withClient ? "mdi-pencil-box-outline" : "mdi-account-search-outline" }}</v-icon>
                <span>{{ withClient ? "Ръчно" : "Клиент" }}</span>
              </v-btn>-->
              <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="elevation-0" @click="openManualCreditNote">
                <v-icon color="#1685c9">mdi-file-upload-outline</v-icon>
                <span>Отвори</span>
              </v-btn>
            </v-row>
          </v-row>
          <v-row v-else class="ma-2 pa-0">
            <v-col v-if="isInStorno" cols="8">
              <v-row justify="start">
                <input class="ma-2 pa-0" id="idCheckboxSelectAll" type="checkbox" dense @change="selectAllArticles" />
                <label class="ma-2 pa-0" for="idCheckboxSelectAll">Маркирай/размаракирай всички</label>
              </v-row>
            </v-col>
            <v-col v-if="isInStorno" cols="4">
              <v-row justify="end">
                <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="elevation-0" @click="finishStorno">
                  <v-icon color="#1685c9">mdi-file-check-outline</v-icon>
                  <span>Издай</span>
                </v-btn>
              </v-row>
            </v-col>
            <v-row v-if="!isInManualStorno && !isInStorno" class="ma-0 pa-0" justify="space-between">
              <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="elevation-0" @click="isInManualStorno = !isInManualStorno">
                <v-icon class="pr-2" color="#1685c9">mdi-pencil-box-outline</v-icon>
                <span>Ръчно</span>
              </v-btn>
              <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="elevation-0" @click="findInvoiceForStorno">
                <v-icon color="#1685c9">mdi-file-search-outline</v-icon>
                <span>Намери</span>
              </v-btn>
            </v-row>
          </v-row>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Tremol from "../assets/fp/fp";
import Const from "../constants";
import KLENparser from "../assets/fp/KLENparser";

export default {
  props: {},
  data() {
    return {
      // error: "",
      isQRRegEx: new RegExp(/^\d{8}\*\d{6}\*\d{4}-\d{2}-\d{2}\*\d{2}:\d{2}:\d{2}\*\d+\.\d{2}$/),
      dialog: true,
      validated: false,
      uicFormat: Tremol.Enums.OptionUICType.Bulstat,
      egnChecksumDigits: ["2", "4", "8", "5", "10", "9", "7", "3", "6"],
      lnchChecksumDigits: ["21", "19", "17", "13", "11", "9", "7", "3", "1"],
      invRcpnt: "",
      invBuyer: "",
      invAddress: "",
      invVAT_Num: "",
      invUIC: "",
      invRcpNum: "",
      rcpNum: null,
      fmNum: "50",
      isInManualStorno: false,
      client: null,
      clients: [],
      withClient: true,
      stornoReason: Tremol.Enums.OptionStornoReason.Tax_relief,
      rcpTime: "00:00:00",
      rcpDate: new Date().toStringWithFormat("yyyy-MM-dd"),
      modalCalendar: false,
      calendarDateSet: false,
      isInStorno: false,
      stornoRcpInfo: {
        rcpType: "",
        dateAndTime: "",
        invoiceNum: Number(null),
        fmNum: Number(null),
        articles: []
      },
      articlesToStorno: [],
      optionUIC: [
        { name: "Булстат", value: Tremol.Enums.OptionUICType.Bulstat },
        { name: "ЕГН", value: Tremol.Enums.OptionUICType.EGN },
        { name: "ЛНЧ", value: Tremol.Enums.OptionUICType.Foreigner_Number },
        { name: "НАП номер", value: Tremol.Enums.OptionUICType.NRA_Official_Number }
      ],
      optionsStornoReasons: [
        {
          name: "Операторска грешка",
          value: Tremol.Enums.OptionStornoReason.Operator_error
        },
        {
          name: "Връщане на стока / рекламация",
          value: Tremol.Enums.OptionStornoReason.Goods_Claim_or_Goods_return
        },
        {
          name: "Намаляване на данъчната основа",
          value: Tremol.Enums.OptionStornoReason.Tax_relief
        }
      ],
      required: [v => !!v || "Задължително поле"],
      validVAT_Num: [v => !!v || "Задължително поле", v => (v.length >= 9 && v.length <= 13) || "ЗДДС номерът трябва да бъде от 9 до 13 символа!"],
      validRcp_Num: [
        v => !!v || "Задължително поле",
        v => {
          if ((!isNaN(parseInt(v)) && v >= 0 && v <= 999999) || (!!v && v.split("*").length == 5 && parseInt(v.split("*")[0]) && parseInt(v.split("*")[1]))) return true;
          return "Невалиден номер на бон";
        }
      ],
      validInv_Buyer: [v => !!v || "Задължително поле", v => v.length <= 16 || "Името на фирмата не може да превиша 16 символа!"],
      validInv_Rcpnt: [v => !!v || "Задължително поле", v => v.length <= 26 || "Името на получателя не може да превиша 26 символа!"],
      validInv_Address: [v => !!v || "Задължително поле", v => v.length <= 30 || "Адресът не може да превиша 30 символа!"],
      validInv_Num: [v => !!v || "Задължително поле", v => v.length == 10 || "Номерът на фактурата трябва да бъде 10 символа!"],
      validFM_Num: [v => !!v || "Задължително поле", v => (v.length == 8 && v.indexOf("50") == 0) || "Номерът на ФП трябва да започва с 50 и да е 8 символа!"],
      validEIK: [v => !!v || "Задължително поле", v => !isNaN(v) || "Моля, въведете само цифри!", v => (v.length >= 9 && v.length <= 13) || "ЕИК/БУЛСТАТ трябва да бъде минимум 9 символа и не повече от 13", v => this.isValidEIK(v) || "Невалиден ЕИК/БУЛСТАТ"],
      validEGN: [v => !!v || "Задължително поле", v => v.length == 10 || "ЕГН трябва да бъде 10 символа", v => this.checkEGN(v) || "Невалиден ЕГН"],
      validLNCH: [v => !!v || "Задължително поле", v => v.length == 10 || "ЛНЧ трябва да бъде 10 символа", v => this.checkLNCH(v) || "Невалиден ЕГН"]
    };
  },
  computed: {
    currentResBP() {
      return this.$vuetify.breakpoint.name;
    },
    chosenUIC() {
      return this.optionUIC.filter(o => o.value == this.uicFormat).map(o => o.name)[0];
    }
  },
  methods: {
    startScanner() {
      this.fp.addMode(Const.Modes.QRScanner, () => {
        if (this.fp.lastQRCode) {
          this.rcpNum = this.fp.lastQRCode;
          this.fp.lastQRCode = "";
        }
      });
    },
    // qrScanned() {
    //   let file = this.$refs.refQRScanner.files[0];
    //   let reader = new FileReader();
    //   reader.readAsText(file, "windows-1251");
    //   reader.onload = evt => {
    //     this.fp.setInfoMessage(evt.target.result);
    //   };
    // },

    fixName() {
      if (this.invBuyer != "") {
        if (this.invBuyer.indexOf("@") > -1) this.invBuyer = this.invBuyer.split("@").join(" ");
      }

      if (this.invAddress != "") {
        if (this.invAddress.indexOf("@") > -1) this.invAddress = this.invAddress.split("@").join(" ");
      }
      if (this.invRcpnt != "") {
        if (this.invRcpnt.indexOf("@") > -1) this.invRcpnt = this.invRcpnt.split("@").join(" ");
      }
    },
    getClients() {
      this.fp.clients.forEach(client => {
        if (client.CustomerCompanyName != "" || client.CustomerFullName != "") {
          client.CustomFirmName = client.CustomerCompanyName + ", " + client.UIC;
          this.clients.push(client);
        }
      });
    },
    selectAllArticles(e) {
      this.articlesToStorno = [];
      if (e.target.checked) {
        this.stornoRcpInfo.articles.forEach(a => {
          if (!a.IsVoided) this.articlesToStorno.push(a);
        });
      }
    },
    clearUIC() {
      this.invUIC = "";
    },
    /** @returns {Date} */
    getFullDate(time, date) {
      let tArr = time.split(":");
      let dt = new Date(date);
      dt.setHours(Number(tArr[0]));
      dt.setMinutes(Number(tArr[1]));
      dt.setSeconds(Number(tArr[2]));
      return dt;
    },
    async rawRead() {
      let resArr = await this.fp.RawRead(0, "@");
      let lines = resArr.toUnicodeString().split("\n");
      let res = [];
      lines.forEach(l => {
        let i = l.substring(4, l.length - 2).win1251toUTF();
        if (i.length > 1) res.push(i);
      });
      return res;
    },
    async openManualCreditNote() {
      if (this.withClient) {
        if (this.$refs.invoiceForm.validate()) {
          try {
            let range = await this.fp.ReadInvoiceRange();
            if (range.StartNum > range.EndNum) {
              await this.fp.SetInvoiceRange(range.StartNum, range.StartNum);
            }
            let client = this.clients.find(clnt => clnt.CustomFirmName == this.client);
            let clientNum = "#" + client.CustomerNum;
            await this.fp.OpenCreditNoteWithFDCustomerDB(1, this.fp.operator1pass, Tremol.Enums.OptionInvoiceCreditNotePrintType.Step_by_step_printing, clientNum, this.stornoReason, this.invRcpNum, this.getFullDate(this.rcpTime, this.rcpDate).toTremolFpString(), this.rcpNum, this.fmNum, null);
            this.cancelCreditNote();
          } catch (err) {
            this.fp.handleException(err);
            //this.cancelCreditNote();
          }
        }
      } else {
        if (this.$refs.invoiceForm.validate()) {
          try {
            await this.fp.OpenCreditNoteWithFreeCustomerData(1, this.fp.operator1pass, Tremol.Enums.OptionInvoiceCreditNotePrintType.Step_by_step_printing, this.invRcpnt, this.invBuyer, this.invUIC, this.invVAT_Num, this.invAddress, this.uicFormat, this.stornoReason, this.invRcpNum, this.getFullDate(this.rcpTime, this.rcpDate).toTremolFpString(), this.rcpNum, this.fmNum, null);
          } catch {
            try {
              let range = await this.fp.ReadInvoiceRange();
              if (range.StartNum > range.EndNum) {
                await this.fp.SetInvoiceRange(range.StartNum, range.StartNum);
              }
              await this.fp.OpenCreditNoteWithFreeCustomerData(1, this.fp.operator1pass, Tremol.Enums.OptionInvoiceCreditNotePrintType.Step_by_step_printing, this.invRcpnt, this.invBuyer, this.invUIC, this.invVAT_Num, this.invAddress, this.uicFormat, this.stornoReason, this.invRcpNum, this.getFullDate(this.rcpTime, this.rcpDate).toTremolFpString(), this.rcpNum, this.fmNum, null);
            } catch (ox) {
              this.fp.handleException(ox);
            } finally {
              this.cancelCreditNote();
            }
          }
        }
      }
    },
    async findInvoiceForStorno() {
      if (this.$refs.invoiceForm.validate()) {
        try {
          // let qr = this.rcpNum.toString().split("*");
          // if (qr.length == 5 && parseInt(qr[0]) && parseInt(qr[1])) {
          //   this.rcpNum = parseInt(qr[1]);
          // }
          this.stornoRcpInfo.articles = [];
          let res_TXT = null;
          await this.fp.executeWithLoader(async () => {
            try {
              await this.fp.ReadEJByReceiptNumCustom(Tremol.Enums.OptionStorageReport.To_PC, Tremol.Enums.OptionCSVformat.No, "66", "64", this.rcpNum, this.rcpNum);
              res_TXT = (await this.rawRead()).join("\r\n");
            } catch (ex) {
              this.fp.handleException(ex);
            }
          }, "Търсене на бона в КЛЕН на ФУ...");
          if (res_TXT == null) {
            return;
          }
          if (res_TXT.length == 0) {
            this.fp.setErrorMessage("Невалиден номер на бон!");
            return;
          }
          var recArr = KLENparser.parse(res_TXT);
          if (recArr.length == 0) {
            this.fp.setErrorMessage("Бон с номер " + this.rcpNum.toString() + " не е фактура!");
            return;
          }
          var recO = recArr[0];
          this.rcpNum = Number(recO.rcpNum);

          if (recO.storno || !recO.invoice) {
            this.fp.setErrorMessage("Бон с номер " + this.rcpNum.toString() + " не е фактура!");
            return;
          }
          this.stornoRcpInfo.dateAndTime = recO.rcpDateTime.parseDateWithFormat(Date.TremolFpFormat);
          this.stornoRcpInfo.fmNum = recO.rcpFMnum;

          var tmpA = [];
          tmpA.push(
            ...recO.articles
              .filter(a => !a.voidFlag)
              .map((a, index) => {
                return {
                  Index: index,
                  Name: a.name,
                  Price: a.price,
                  Qty: a.qty,
                  Price_Total: a.artTotalSum,
                  IsVoided: a.voidFlag,
                  VAT: a.taxgr
                };
              })
          );
          recO.articles
            .filter(a => a.voidFlag)
            .forEach(va => {
              var foundIdx = tmpA.findIndex(a => a.IsVoided == false && a.Name == va.name && a.Price == va.price && a.Qty == va.qty && a.Price_Total == va.artTotalSum && a.VAT == va.taxgr);
              if (foundIdx > -1) {
                tmpA[foundIdx].IsVoided = true;
              }
            });
          this.stornoRcpInfo.articles = tmpA;
          this.stornoRcpInfo.invoiceNum = recO.invNumber;
          this.stornoRcpInfo.Buyer = recO.invBuyer;
          this.invRcpnt = recO.invRecipient;
          this.invBuyer = recO.invBuyer;
          this.invAddress = recO.invAddress;
          this.invUIC = recO.invUICnumber;
          this.invVAT_Num = recO.invVATnumber;

          this.isInStorno = true;
        } catch (err) {
          this.fp.setErrorMessage("Грешка при обработка на бон " + this.rcpNum + ". " + err);
          this.isInManualStorno = true;
          this.$refs.invoiceForm.validate();
        }
      }
    },
    async finishStorno() {
      await this.fp.executeWithLoader(async () => {
        try {
          let range = await this.fp.ReadInvoiceRange();
          if (range.StartNum >= range.EndNum) {
            await this.fp.SetInvoiceRange(Number(range.EndNum + 1), Number(range.EndNum + 1));
          }
          await this.fp.OpenCreditNoteWithFreeCustomerData(1, this.fp.operator1pass, Tremol.Enums.OptionInvoiceCreditNotePrintType.Postponed_Printing, this.invRcpnt, this.invBuyer, this.invVAT_Num, this.invUIC, this.invAddress, this.uicFormat, this.stornoReason, this.stornoRcpInfo.invoiceNum, this.stornoRcpInfo.dateAndTime.toTremolFpString(), this.rcpNum, this.stornoRcpInfo.fmNum, null);
          await this.articlesToStorno.asyncForEach(async plu => {
            await this.fp.SellPLUwithSpecifiedVAT(plu.Name, plu.VAT, plu.Price, plu.Qty);
          });
          await this.fp.CashPayCloseReceipt();
          this.cancelCreditNote();
        } catch (ex) {
          this.fp.handleException(ex);
        }
      }, "Отпечатване на кредитно известие...");
    },
    checkLNCH(n) {
      let sum = 0;
      let checksum = 0;
      for (let i = 0; i < n.length - 1; i++) {
        sum = sum + this.lnchChecksumDigits[i] * n.charAt(i);
      }
      if (checksum % 10 == n.slice(-1)) {
        return true;
      } else {
        return false;
      }
    },
    checkEGN(n) {
      let sum = 0;
      let checksum = 0;
      for (let i = 0; i < n.length - 1; i++) {
        sum = sum + this.egnChecksumDigits[i] * n.charAt(i);
      }
      if (sum % 11 == 0 || sum % 11 == 10) {
        checksum = 0;
      } else {
        checksum = sum % 11;
      }
      if (checksum == n.slice(-1)) {
        return true;
      } else {
        return false;
      }
    },
    cancelCreditNote() {
      this.articlesToStorno = [];
      this.stornoRcpInfo.articles = [];
      this.isInManualStorno = false;
      this.isInStorno = false;
      this.fp.exitMode(Const.Modes.CreditNote);
    },
    isValidEIK(v) {
      var matches;
      if (!(matches = v.match(/^(BG)?((\d{9})(\d{4})?)$/))) return false;

      //1*а1+2*а2+3*а3+4*а4+5*а5+6*а6+7*а7+8*а8;
      var a = matches[3];
      var a9 = a[0] * 1 + a[1] * 2 + a[2] * 3 + a[3] * 4 + a[4] * 5 + a[5] * 6 + a[6] * 7 + a[7] * 8;
      a9 = a9 % 11;

      if (a9 == 10) {
        //3*а1+4*а2+5*а3+6*а4+7*а5+8*а6+9*а7+10*а8
        a9 = a[0] * 3 + a[1] * 4 + a[2] * 5 + a[3] * 6 + a[4] * 7 + a[5] * 8 + a[6] * 9 + a[7] * 10;
        a9 = a9 % 11;
      }

      a9 = a9 == 10 ? 0 : a9;

      if (a9 != a[8]) return false;
      if (!matches[4]) return true;

      //2*а9 + 7*а10 + 3*а11 +5*а12
      a = matches[4];
      var a13 = a9 * 2 + a[0] * 7 + a[1] * 3 + a[2] * 5;
      a13 = a13 % 11;

      //4*а9+9*а10+5*а11+7*а12
      if (a13 == 10) {
        a13 = a9 * 4 + a[0] * 9 + a[1] * 5 + a[2] * 7;
        a13 = a13 % 11;
      }

      a13 = a13 == 10 ? 0 : a13;
      return a13 == a[3];
    }
  },

  watch: {
    rcpNum(val) {
      if (val.toString().match(this.isQRRegEx)) {
        this.$nextTick(() => {
          let qrArr = val.split("*");
          this.rcpNum = Number(qrArr[1]);
          this.fmNum = qrArr[0];
          this.stornoRcpInfo.fmNum = qrArr[0];
          this.rcpDate = qrArr[2];
          this.rcpTime = qrArr[3];
          this.$nextTick(() => {
            this.findInvoiceForStorno();
          });
        });
      }
    }
  },
  mounted() {
    if (this.fp.maxSupportedClients == 0) {
      this.withClient = false;
      //this.isInManualStorno = true;
    } else {
      this.withClient = true;
      //this.isInManualStorno = false;
    }

    this.getClients();
  }
};
</script>